<template>
    <div>
        <fieldset v-if="customFieldGroup && groupCustomFields.length > 0">
            <legend>{{ customFieldGroup.group === standaloneFieldsGroupName ? '' : customFieldGroup.label }}</legend>
            <div class="md-layout">
                <CustomFieldInputs
                    v-for="(customField, index) in groupCustomFields"
                    :key="index"
                    :custom-field-definition="customField"
                    :initial-value="localGroupValues[customField.name]"
                    @changed="handleCustomFieldChanged"
                    class="md-layout-item"
                />
            </div>
        </fieldset>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { STANDALONE_FIELDS_GROUP } from '@/utils/customFields';
import CustomFieldInputs from './CustomFieldInputs';

export default {
    name: 'CustomFieldGroup',
    mixins: [GeneralMixin],
    components: {
        CustomFieldInputs
    },
    props: {
        customFieldGroup: {
            type: Object,
            required: true
        },
        groupValues: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    data() {
        return {
            standaloneFieldsGroupName: STANDALONE_FIELDS_GROUP
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
        localGroupValues() {
            return this.groupValues || {};
        },
        groupCustomFields() {
            if (!this.customFieldGroup) {
                return [];
            }

            return this.customFieldGroup.fields || [];
        }
    },
    methods: {
        handleCustomFieldChanged(customField) {
            this.groupValues[customField.name] = customField.value;
            this.$emit('changed', { group: this.customFieldGroup.group, groupValues: { ...this.groupValues } });
        }
    }
};
</script>
